import React from 'react';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Box, Button, Stack, Typography } from '@mui/material';

import { ConflictInfo, ConflictResolution } from '~/types/stopsell';

import { formatDateRange } from '~/utils/stopsellDateUtils';

interface Props {
  conflict: ConflictInfo;
  resolution: ConflictResolution;
  onUndo: () => void;
}

export default function StopsellResolvedBanner({ conflict, resolution, onUndo }: Props) {
  const existingLabel = formatDateRange(conflict.existingRange.start, conflict.existingRange.end);
  const mergedLabel = conflict.mergedRange ? formatDateRange(conflict.mergedRange.start, conflict.mergedRange.end) : '';

  const message =
    resolution === 'ignored'
      ? `Ignored (covered by ${existingLabel})`
      : resolution === 'overriding'
      ? `Will override existing ${existingLabel}`
      : `Will extend to include ${existingLabel} → ${mergedLabel}`;

  return (
    <Box
      sx={{
        ml: 4,
        p: 1,
        pl: 1.5,
        borderRadius: 1,
        bgcolor: 'success.50',
        border: '1px solid',
        borderColor: 'success.200',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Stack direction="row" alignItems="center" gap={0.75}>
        <CheckCircleOutlineIcon sx={{ fontSize: 15, color: 'success.main' }} />
        <Typography variant="caption" color="success.dark">
          {message}
        </Typography>
      </Stack>
      <Button size="small" onClick={onUndo} sx={{ fontSize: 11, py: 0, minWidth: 0 }}>
        Undo
      </Button>
    </Box>
  );
}
